<c-container>
  <h1 class="mt-5">Manage Notifications</h1>


  @if (isCausableAdmin) {
    <app-causable-admin-manage-notifications></app-causable-admin-manage-notifications>
  } @else if (hasCrossGamePermission) {
    <app-cross-game-manage-notifications></app-cross-game-manage-notifications>
  } @else {
    <app-game-admin-manage-notifications></app-game-admin-manage-notifications>
  }
</c-container>
